/*  eslint no-underscore-dangle: ["error", { "allow": ["_id"] }]*/

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Table, Input, Button, Pagination } from 'antd'
import { history } from '../../../store'

import './index.css'
import queryString from "query-string";

const propTypes = {
  clientList: PropTypes.array.isRequired,
  getClientList: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  clientCount: PropTypes.number.isRequired,
}
const defaultProps = {
  clientList: [],
  isFetching: false,
  clientCount: 0,
}

const columns = [
  {
    title: 'Ilness',
    dataIndex: 'illness',
    // sorter: true,
  },
  {
    title: 'From',
    dataIndex: 'from',
  },
  {
    title: 'Full name',
    dataIndex: 'fullName',
    render: (name, record) => <Link to={`/clients/${record._id}`}>{name}</Link>,
  },
  {
    title: 'Profession',
    dataIndex: 'profession',
  },
  {
    title: 'Age',
    dataIndex: 'age',
  },
  {
    title: 'Rating',
    dataIndex: 'rating',
  },
  {
    title: 'Telephone number',
    dataIndex: 'telephoneNumber',
    render: tel => (tel.length ? tel.map((t, i) => <p key={i}>{t}</p>) : ''),
  },
  {
    title: 'Desctiption',
    dataIndex: 'description',
  },
  {
    render: (name, record) => <Link to={`/manipulations?clientId=${record._id}&search=${record.fullName}`}>
      <Button icon='medicine-box' />
    </Link>,
  },
]

export class Clients extends Component {
  constructor() {
    super()
    this.state = {}
    this.clearSearch = this.clearSearch.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onShowSizeChange = this.onShowSizeChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
  }
  componentDidMount() {
    this.props.getClientList()
  }
  // handleTableChange = (pagination, filters, sorter) => {
  //   console.log(pagination, filters, sorter)
  // }
  onShowSizeChange(current, pageSize) {
    const { location, getClientList } = this.props
    const parsed = queryString.parse(location.search)
    parsed.perPage = pageSize
    parsed.page = current
    history.push({
      pathname: '/clients',
      search: queryString.stringify(parsed)
    })
    getClientList()
  }
  onPageChange(pageNumber) {
    const { location, getClientList } = this.props
    const parsed = queryString.parse(location.search)
    parsed.page = pageNumber
    history.push({
      pathname: '/clients',
      search: queryString.stringify(parsed)
    })
    getClientList()
  }

  onSearchChange(val) {
    const { location, getClientList } = this.props
    const parsed = queryString.parse(location.search)
    val ? parsed.search = val : delete parsed.search
    history.push({
      pathname: '/clients',
      search: queryString.stringify(parsed)
    })
    getClientList()
  }

  clearSearch() {
    const { location, getClientList } = this.props
    this.searchField.input.input.value = ''
    const parsed = queryString.parse(location.search)
    delete parsed.search
    history.push({
      pathname: '/clients',
      search: queryString.stringify(parsed)
    })
    getClientList()
  }


  render() {
    const { clientList, isFetching, clientCount, location } = this.props
    const { search, perPage, page } = queryString.parse(location.search)
    return (
      <div className='clients'>
        <div className='first-row'>
          <Link to={'/clients/new'}>
            <Button size='large' type='primary' icon='user-add'>Add new</Button>
          </Link>
          <Input.Search
            ref={node => (this.searchField = node)}
            placeholder='Type to search clients...'
            size={'large'}
            defaultValue={search || ''}
            onSearch={this.onSearchChange}
          />
          <Button
            size='large'
            icon='reload'
            onClick={this.clearSearch}
          />
        </div>
        <Table
          columns={columns}
          rowKey={record => record._id}
          dataSource={clientList}
          pagination={false}
          loading={isFetching}
          // onChange={this.handleTableChange}
        />
        <div className='second-row'>
          <Pagination
            showSizeChanger
            pageSize={Number(perPage) || 30}
            pageSizeOptions={['10', '30', '50', '100']}
            onShowSizeChange={this.onShowSizeChange}
            onChange={this.onPageChange}
            defaultCurrent={Number(page) || 1}
            total={clientCount}
          />
        </div>
      </div>
    )
  }
}


Clients.propTypes = propTypes
Clients.defaultProps = defaultProps
export default Clients



// WEBPACK FOOTER //
// ./src/containers/clients/list/Clients.js